export type Timer = ReturnType<typeof setTimeout>;

export enum ContractFunctionNames {
  ROOM_ID_COUNTER = 'roomIdCounter',
  ACTIVE_ROOM_COUNTER = 'activeRoomCounter',
  GET_ROOMS_INFO = 'getRoomsInfo',
}

export enum TxStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Confirmed = 'confirmed',
  Failed = 'failed',
}
